import * as React from "react";
import { FC } from "react";
import { Create, CreateProps, SimpleForm } from "react-admin";
import { TitleMro } from "./Constant/Source";
import MroCreateForm from "./Forms/MroCreateForm";

const MroCreate: FC<CreateProps> = props => {
  return (
    <Create {...props} title={TitleMro.create}>
      <SimpleForm>
        <MroCreateForm />
      </SimpleForm>
    </Create>
  );
};

export default MroCreate;
